"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Picture = Picture;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["className", "dataTestId", "sources", "fallbackSource", "isLazy", "fetchPriority", "alt"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var propTypes = {
  alt: _propTypes["default"].string,
  fallbackSource: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  fetchPriority: _propTypes["default"].oneOf(['auto', 'high', 'low']),
  isLazy: _propTypes["default"].bool,
  sources: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    srcSet: _propTypes["default"].string.isRequired,
    type: _propTypes["default"].string.isRequired
  }))
};
var defaultProps = {
  alt: '',
  className: '',
  dataTestId: 'fuse-picture-data-test-id',
  fetchPriority: undefined,
  isLazy: false,
  sources: undefined
};
function Picture(_ref) {
  var className = _ref.className,
    dataTestId = _ref.dataTestId,
    sources = _ref.sources,
    fallbackSource = _ref.fallbackSource,
    isLazy = _ref.isLazy,
    fetchPriority = _ref.fetchPriority,
    alt = _ref.alt,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "fuse-picture ".concat(className),
    "data-testid": dataTestId
  }, props), (sources === null || sources === void 0 ? void 0 : sources.length) > 0 ? sources.map(function (_ref2) {
    var srcSet = _ref2.srcSet;
    return (/*#__PURE__*/
      // TODO: need to get the alt text for the images from CMS
      // eslint-disable-next-line jsx-a11y/alt-text
      _react["default"].createElement("img", {
        className: "fuse-picture__img",
        alt: alt,
        key: srcSet,
        src: srcSet,
        fetchpriority: fetchPriority,
        loading: isLazy ? 'lazy' : undefined
      })
    );
  }) : /*#__PURE__*/_react["default"].createElement("img", {
    className: "fuse-picture__img",
    alt: alt,
    src: fallbackSource,
    fetchpriority: fetchPriority,
    loading: isLazy ? 'lazy' : undefined
  }));
}
Picture.propTypes = propTypes;
Picture.defaultProps = defaultProps;
var _default = exports["default"] = Picture;